import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpLaravelHeaders } from '@app/_interceptors/url.interceptor';
import { ResponseObject } from '@app/_shared/interfaces';
import { Company } from '@app/_shared/interfaces/http/statistics/company';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private _http = inject(HttpClient);

  private headers = new HttpLaravelHeaders();

  private endpoint = '/api/v1/user/statistics/companies';

  index(params?: HttpParams) {
    return this._http.get<ResponseObject<Company>>(this.endpoint, {
      headers: this.headers,
      params,
    });
  }
}
